export default __webpack_public_path__ + "424fcbb09642efcf555fc473a01cbe7c.png";